import React from 'react';
export function HorizontalHeaderSection() {
  return <section className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-1862">
      <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-1863">
        EDMMax Fast Wire – Horizontal
      </h2>
    </section>;
}